/** Viewports and devices where scroll-reveal and deferral should be disabled. */
export const STATIC_SECTIONS_MEDIA_QUERY =
  "(max-width: 1023px), (hover: none) and (pointer: coarse)";

export function prefersStaticSections() {
  if (typeof window === "undefined") {
    return false;
  }

  return (
    window.matchMedia("(max-width: 1023px)").matches ||
    window.matchMedia("(hover: none) and (pointer: coarse)").matches
  );
}

export function subscribeStaticSections(onChange: () => void) {
  const narrow = window.matchMedia("(max-width: 1023px)");
  const coarse = window.matchMedia("(hover: none) and (pointer: coarse)");

  const handleChange = () => onChange();
  narrow.addEventListener("change", handleChange);
  coarse.addEventListener("change", handleChange);

  return () => {
    narrow.removeEventListener("change", handleChange);
    coarse.removeEventListener("change", handleChange);
  };
}
